"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("../utils");
class Collection {
  constructor() {
    this.store = new Map();
  }
  get items() {
    return Array.from(this.store.entries()).reduce((result, _ref) => {
      let [key, value] = _ref;
      result[key] = value;
      return result;
    }, {});
  }
  get count() {
    return this.store.size;
  }
  has(key) {
    return (0, _utils.isset)(this.get(key));
  }
  get(key) {
    return this.store.get(key);
  }
  add(key, item) {
    this.store.set(key, item);
  }
  remove(key) {
    this.store.delete(key);
  }
  each(fn) {
    const items = this.items;
    Object.keys(items).forEach(key => fn(key, items[key]));
  }
}
var _default = exports.default = Collection;
module.exports = exports.default;